import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { toast } from "sonner";
import { capi, formatApiError, clearCustomerSession } from "@/lib/api";
import { InvoicePaper } from "@/components/InvoicePaper";

export default function InvoiceView() {
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);

  useEffect(() => {
    capi.get(`/customer/invoices/${orderNumber}`)
      .then(({ data }) => setInv(data))
      .catch((e) => {
        if (e?.response?.status === 401) { clearCustomerSession(); navigate("/account/login"); return; }
        toast.error(formatApiError(e));
        navigate("/account");
      });
  }, [orderNumber]);

  if (!inv)
    return (
      <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E7B3A]">Loading…</p>
      </div>
    );

  return (
    <div className="min-h-screen bg-[#FAF7F0] py-10 px-4" data-testid="customer-invoice-page">
      <style>{`@media print {
        body { background: #ffffff !important; }
        .no-print { display: none !important; }
        .invoice-paper { border: none !important; box-shadow: none !important; margin: 0 !important; max-width: 100% !important; width: 100% !important; }
      }`}</style>
      <div className="no-print max-w-3xl mx-auto mb-6 flex items-center justify-between">
        <button onClick={() => navigate("/account")} data-testid="customer-invoice-back"
          className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#4A4A4A] hover:text-[#9E7B3A] transition-colors duration-300">
          <ArrowLeft className="w-4 h-4" /> Back to Messages
        </button>
        <button onClick={() => window.print()} data-testid="customer-invoice-print"
          className="flex items-center gap-2 border border-[#C5A059]/50 bg-white text-xs tracking-[0.2em] uppercase px-5 py-3 text-[#4A4A4A] hover:border-[#9E7B3A] hover:text-[#9E7B3A] transition-colors duration-300">
          <Printer className="w-4 h-4" /> Print / Save PDF
        </button>
      </div>
      <InvoicePaper inv={inv} />
    </div>
  );
}
